module.exports = __webpack_public_path__ + "static/media/about-us-banner-mobile.126390da.jpg";